module.exports = __webpack_public_path__ + "static/estrutura-suite-ldr-3e615629689bb8f436b8c7a0059a587c.jpg";